<template>
    <div id="download">
        <!-- ----------------------------文件下載開始---------------------------- -->
        <section class="cm-customercenter-download-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <div class="cm-triangle-font">
                    {{$t('download.DownloadBar')}}
                </div>
            </div>

            <DownloadContent></DownloadContent>

            <br/>
            <div class="cm-customercenter-download-banner-line"></div>
        </section>
        <!-- ----------------------------文件下載結束---------------------------- -->
    </div>
</template>

<script>
import DownloadContent from "@/components/DownloadContent";
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js';


export default {
    name:"download",
     components: {
        DownloadContent
    },
    data() {
        return {
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg"),
        };
    },
    mounted() {
        this.updateTopBackgroundImg();
        
        // 更換語言時
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_DOWNLOAD, function(i18n) {
            self.updateTopBackgroundImg(i18n);
        });

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);
    },
    methods: {
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        }
    }
}
</script>